import { INT_MAX_SIGNED_32_BIT_VALUE } from 'src/globals/globals';

export default class IPBoardPlacementType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const IPBoardPlacementTypeChoices = {
  ATTACHED_TO_FACADE: new IPBoardPlacementType('Gevel', 0),
  BALCONY: new IPBoardPlacementType('Balkon', 1),
  STRETCHED: new IPBoardPlacementType('Opgespannen', 2),
  ON_POSTS: new IPBoardPlacementType('Op palen', 3),
  ON_STONES: new IPBoardPlacementType('Stenen', 4),
  WINDOW: new IPBoardPlacementType('Raam', 5),
  OTHER: new IPBoardPlacementType('Andere', INT_MAX_SIGNED_32_BIT_VALUE)
};

export const IPBoardPlacementTypeChoicesArray = Object.values(
  IPBoardPlacementTypeChoices
);

export const AdhesiveBoardPlacementTypeChoicesArray: AdhesivePlacementTypeChoice[] = [
  { label: 'Aan een raam kleven', value: IPBoardPlacementTypeChoices.WINDOW },
  {
    label: 'Aan een glazen balkon kleven',
    value: IPBoardPlacementTypeChoices.BALCONY
  },
  { label: 'Andere', value: IPBoardPlacementTypeChoices.OTHER }
];

export interface AdhesivePlacementTypeChoice {
  label: string;
  value: IPBoardPlacementType;
}
